import React from 'react';
import {Link,useNavigate, useSearchParams} from 'react-router-dom';

import swal from 'sweetalert';

import config from '../../inc/config'
import { getCookie } from '../../inc/cookies';
import {formatPlate, getCreditStatusName, isoToDateTime, priceFormat, slugify} from '../../inc/helper';
import Images from '../../utilies/Images';


class AuctionVehicleDetailModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,

      auctionVehicle: {},
      partsStatus: [{id: 'original', name: 'Orijinal'}, {id: 'replaced', name: 'Değişmiş'}, {id: 'painted', name: 'Boyalı'}, {id: 'localPainted', name: 'Lokal Boyalı'}, {id: 'plastic', name: 'Plastik Aksan'}]
    };
  }

  componentDidMount() {
    this.getAuctionVehicleDetail();
    window.scrollTo(0, 0);
  }

  getAuctionVehicleDetail() {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'auctionVehicle/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200:
          this.setState({isLoading: false, auctionVehicle: responseData.auctionVehicleInfo})
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/expertises'))
        break;
        default:
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        break;
      }
    }, () =>swal({ dangerMode: true, icon: "error", title: "Bağlantı Hatası", text: "Lütfen internet bağlantınızı kontrol ediniz.", buttons: "Yeniden Dene",}).then(() => this.getMyAppointmentsDetail()));
  }

  phoneFormat(phone) {
    let parsedValue = /^(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(phone);
    return parsedValue ? '(' + parsedValue[1] + ') ' + parsedValue[2] + ' ' + parsedValue[3] + ' ' + parsedValue[4] : '-';
  }

  formatPlate = (plate) => {
    return plate.replace(/(\d{2})([a-zA-Z]+)(\d+)/, "$1 $2 $3").toUpperCase();
  };

  formatKilometer = (km) => {
    return `${km.toLocaleString("tr-TR")}`;
  };

  render() {
    return this.state.isLoading ?
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
      :
      <div className="col-lg-12">
        <div className="row">
          <div className="col">
            <div className="ibox">
              <div className="ibox-title text-darkblue d-flex justify-content-between pr-2">
                <h4>Araç Bilgileri</h4>
                <div className="d-flex">
                  <button className="btn border btn-darkblue text-white" onClick={() => this.props.navigate(-1)} title="Geri"> <i className="fa fa-reply"></i></button>
                </div>
              </div>
              <div className="ibox-content">
                <div className="row mt-4">
                  <div className="col">
                    <h4 className="text-orange">ARAÇ DETAYLARI</h4>
                    <div className="hr-line-dashed mt-0"></div>
                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Araç No:</h4>
                          <span>{this.state.auctionVehicle.id || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Araç Başlığı:</h4>
                          <span>{this.state.auctionVehicle.title || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Marka - Model: </h4>
                          <span>{this.state.auctionVehicle.vehicleBrandName || ''} {this.state.auctionVehicle.vehicleModelName || ''} {this.state.auctionVehicle.vehicleEquipmentName || ''}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Araç yılı: </h4>
                          <span>{this.state.auctionVehicle.year || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">KM: </h4>
                          <span>{this.formatKilometer(this.state.auctionVehicle.details.km) || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Plaka: </h4>
                          <span>{formatPlate(this.state.auctionVehicle.details.plateNumber) || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Renk: </h4>
                          <span>{this.state.auctionVehicle.details.color || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Yakıt Tipi: </h4>
                          <span>{this.state.auctionVehicle.details.fuelType || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Vites Tipi: </h4>
                          <span>{this.state.auctionVehicle.details.transmissionType || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Çekiş Tipi: </h4>
                          <span>{this.state.auctionVehicle.details.tractionType || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Motor Gücü: </h4>
                          <span>{this.state.auctionVehicle.details.engineCapacity || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Motor No: </h4>
                          <span>{this.state.auctionVehicle.details.engineNumber || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Şasi No: </h4>
                          <span>{this.state.auctionVehicle.details.chassisNumber || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Ruhsat Cinsi: </h4>
                          <span>{this.state.auctionVehicle.details.registrationType || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Ruhsat Tipi: </h4>
                          <span>{this.state.auctionVehicle.details.registrationCode || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Sertifika No: </h4>
                          <span>{this.state.auctionVehicle.details.authorizationCertificateNumber || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Açıklama: </h4>
                          <span>{this.state.auctionVehicle.comment || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Satış Durumu: </h4>
                          <span>{this.state.auctionVehicle.soldStatus === 0 ? 'Satılmadı' :  'Satıldı'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Ekleyen Kişi: </h4>
                          <span>{this.state.auctionVehicle.addedFullName || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Eklenme Tarihi: </h4>
                          <span>{isoToDateTime(this.state.auctionVehicle.addedDate) || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Düzenleyen Kişi: </h4>
                          <span>{this.state.auctionVehicle.modifiedFullName || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Düzenlenme Tarihi: </h4>
                          <span>{isoToDateTime(this.state.auctionVehicle.modifiedDate) || '-'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <h4 className="text-orange">DEĞERLENDİRME SONUCU (Ekspertiz ve Tramer)</h4>
                    <div className="hr-line-dashed mt-0" />
                    <div className="row">
                      <div className="col-12 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Tramer:</h4>
                          <span>{this.state.auctionVehicle.appraisalResult?.comment || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Ön Tampon:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.frontBumper)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Arka Tampon:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.rearBumper)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Ön Kaput:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.frontHood)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Arka Kaput:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.rearHood)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Ön Sol Kapı:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.frontLeftDoor)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Arka Sol Kapı:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.rearLeftDoor)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Ön Sol Çamurluk:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.frontLeftMudguard)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Arka Sol Çamurluk:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.rearLeftMudguard)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Ön Sağ Kapı:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.frontRightDoor)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Arka Sağ Kapı:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.rearRightDoor)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Ön Sağ Çamurluk:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.frontRightMudguard)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Arka Sağ Çamurluk:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.rearRightMudguard)?.name || '-'}</span>
                        </div>
                      </div>
                      <div className="col-md-6 mb-2">
                        <div className="d-flex flex-column">
                          <h4 className="font-bold text-darkblue mb-0">Tavan:</h4>
                          <span>{this.state.partsStatus.find(status => status.id === this.state.auctionVehicle.appraisalResult?.parts?.roof)?.name || '-'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <h4 className="text-orange">ÖZELLİK BİLGİLERİ</h4>
                    <div className="hr-line-dashed mt-0" />
                    <h4 className="font-bold text-orange mb-2">Donanım Özellikleri</h4>
                    {Object.keys(this.state.auctionVehicle.vehicleEquipmentDetails).length === 0 && <span>-</span>}
                    <div className="row">
                      {Object.keys(this.state.auctionVehicle.vehicleEquipmentDetails).length > 0 && this.state.auctionVehicle?.vehicleEquipmentDetails?.equipment.map((group, groupIndex) => (
                        <div className="col-md-6 mb-3" key={`eq-group-${groupIndex}`}>
                          <h4 className="font-bold text-darkblue mb-2">{group.group}</h4>
                          <ul className="list-unstyled">
                            {group.items.map((item, itemIndex) => (
                              <li key={`eq-item-${itemIndex}`} className="mb-1">
                                • {item}
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                    <h4 className="font-bold text-orange mb-2">Teknik Özellikleri</h4>
                    {Object.keys(this.state.auctionVehicle.vehicleEquipmentDetails).length === 0 && <span>-</span>}
                    <div className="row">
                      {Object.keys(this.state.auctionVehicle.vehicleEquipmentDetails).length > 0 && this.state.auctionVehicle?.vehicleEquipmentDetails?.specs.map((group, groupIndex) => (
                        <div className="col-12 mb-3" key={`spec-group-${groupIndex}`}>
                          <h4 className="font-bold text-orange mb-2">{group.group}</h4>
                          <div className="row">
                            {group.items.map((item, itemIndex) => (
                              <div className="col-md-6 mb-2" key={`spec-item-${itemIndex}`}>
                                <div className="d-flex flex-column">
                                  <h4 className="mb-0 font-weight-bold">{item.label}:</h4>
                                  <span>{item.value || '-'}</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <h4 className="text-orange">KATILDIĞI İHALELER</h4>
                    <div className="hr-line-dashed mt-0" />
                    <div className="table-responsive-lg mb-5">
                      {this.state.auctionVehicle?.auctionItems.length !== 0 ?
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr className="text-black">
                            <th>Araç Adı</th>
                            <th>Konum</th>
                            <th>Açılış Fiyatı</th>
                            <th>Eşik Fiyatı</th>
                            <th>Başlangıç Tarihi</th>
                            <th>Bitiş Tarihi</th>
                            <th>Detay</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.auctionVehicle?.auctionItems?.map((auctionVehicle, index) =>
                            <tr key={index}>
                              <td className="align-middle">{auctionVehicle.auctionTitle}<br />Araç No #:{auctionVehicle.id}</td>
                              <td className="align-middle">{auctionVehicle.cityName} / {auctionVehicle.townName}</td>
                              <td className="align-middle">{priceFormat(auctionVehicle.initialPrice)} ₺</td>
                              <td className="align-middle">{priceFormat(auctionVehicle.thresholdPrice)} ₺</td>
                              <td className="align-middle">{isoToDateTime(auctionVehicle.auctionItemStartDate)}</td>
                              <td className="align-middle">{isoToDateTime(auctionVehicle.auctionItemEndDate)}</td>
                              <td className="align-middle" style={{minWidth:98.5}}>
                                <Link className="btn btn-orange" title="İhale Araç Detayı" to={`/auctionItemDetail?id=${auctionVehicle.id}`}><i className="fa fa-eye"></i></Link>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      :
                      <div className="text-center"><strong>Aracın Katıldığı İhale Bulunamadı !</strong></div>}
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <h4 className="text-orange">FOTOĞRAFLAR ({this.state.auctionVehicle?.photos.length})</h4>
                    <div className="hr-line-dashed mt-0" />
                    <div className="row">
                      {this.state.auctionVehicle?.photos.length !== 0 ?
                        this.state.auctionVehicle?.photos.map(photo =>
                        <div className="col-xl-6">
                          <div style={{ position: "relative", display: "inline-block", border:"1px solid lightgray", backgroundColor: "#F5F5F5"}}>
                            <img className='col-12 p-0' style={{height:250, width:389, objectFit:"contain", overflow: "visible", display: "block"}} src={`https://file.satisgaranti.com/${photo.path}`}/>
                            <img style={{position: "absolute", top: 0, left: 0}} src={this.state.auctionVehicle?.photos[0].path === photo.path  ? Images.showCase : ''}/>
                          </div>
                        </div>
                      ): <div className="col-12 d-flex justify-content-center">İlana Ait Fotoğraf Bulunamadı !</div>}
                    </div>
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col">
                    <h4 className="text-orange">HASAR GEÇMİŞİ</h4>
                    <div className="hr-line-dashed mt-0" />
                    <div className="row">
                      {this.state.auctionVehicle?.damagePhotos.length !== 0 ?
                        this.state.auctionVehicle?.damagePhotos.map(photo =>
                        <div className="col-xl-6">
                          <div style={{ position: "relative", display: "inline-block", border:"1px solid lightgray", backgroundColor: "#F5F5F5"}}>
                            <img className='col-12 p-0' style={{height:250, width:389, objectFit:"contain", overflow: "visible", display: "block"}} src={`https://file.satisgaranti.com/${photo.path}`}/>
                            <img style={{position: "absolute", top: 0, left: 0}} src={this.state.auctionVehicle?.damagePhotos[0].path === photo.path  ? Images.showCase : ''}/>
                          </div>
                        </div>
                      ): <div className="col-12 d-flex justify-content-center">İlana Ait Hasar Fotoğrafı Bulunamadı !</div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  }
}

export default function AuctionVehicleDetail() {
  return (
    <AuctionVehicleDetailModule navigate={useNavigate()} searchParams={useSearchParams()[0]} />
  )
}